@for (toast of toastService.toasts(); track toast.id) {
	<ui-toast
		[title]="toast.title"
		[text]="toast.text"
		[color]="toast.color"
		presentationMode="fixed"
		position="top-right"
		[duration]="0"
		[closeAriaLabel]="'uiKit.toast.closeAria' | translate"
		(closed)="toastService.dismiss(toast.id)"
	/>
}
